var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditDetails({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1182 3.69042L9.53196 1.10477C9.44598 1.01877 9.34389 0.950544 9.23154 0.903998C9.11919 0.857453 8.99877 0.833496 8.87716 0.833496C8.75554 0.833496 8.63512 0.857453 8.52277 0.903998C8.41042 0.950544 8.30834 1.01877 8.22235 1.10477L1.08636 8.24076C1 8.32643 0.931539 8.42841 0.884946 8.54077C0.838352 8.65314 0.814557 8.77364 0.814946 8.89528V11.4815C0.814946 11.7271 0.912499 11.9626 1.08614 12.1362C1.25979 12.3099 1.4953 12.4074 1.74087 12.4074H11.4631C11.5859 12.4074 11.7036 12.3587 11.7905 12.2718C11.8773 12.185 11.9261 12.0673 11.9261 11.9445C11.9261 11.8217 11.8773 11.7039 11.7905 11.6171C11.7036 11.5303 11.5859 11.4815 11.4631 11.4815H5.63671L12.1182 5.00002C12.2042 4.91404 12.2724 4.81196 12.319 4.6996C12.3655 4.58725 12.3895 4.46683 12.3895 4.34522C12.3895 4.22361 12.3655 4.10319 12.319 3.99083C12.2724 3.87848 12.2042 3.7764 12.1182 3.69042ZM4.3271 11.4815H1.74087V8.89528L6.83346 3.80268L9.41969 6.38891L4.3271 11.4815ZM10.0742 5.7344L7.48856 3.14817L8.87745 1.75928L11.4631 4.34551L10.0742 5.7344Z",
    fill: "#45852E",
    stroke: "#45852E",
    strokeWidth: 0.37037
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditDetails);
export default __webpack_public_path__ + "static/media/editDetails.d2631b2e39aeffa765601a59ddb55118.svg";
export { ForwardRef as ReactComponent };